var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.38331 26.25C3.02914 26.25 2.73206 26.13 2.49206 25.89C2.25206 25.65 2.13247 25.3533 2.13331 25C2.13331 24.6458 2.25331 24.3488 2.49331 24.1088C2.73331 23.8688 3.02997 23.7492 3.38331 23.75H28.3833C28.7375 23.75 29.0346 23.87 29.2746 24.11C29.5146 24.35 29.6341 24.6467 29.6333 25C29.6333 25.3542 29.5133 25.6513 29.2733 25.8913C29.0333 26.1313 28.7366 26.2508 28.3833 26.25H3.38331ZM5.88331 22.5C5.19581 22.5 4.60705 22.255 4.11705 21.765C3.62705 21.275 3.38247 20.6867 3.38331 20V6.25C3.38331 5.5625 3.62831 4.97375 4.11831 4.48375C4.60831 3.99375 5.19664 3.74917 5.88331 3.75H25.8833C26.5708 3.75 27.1596 3.995 27.6496 4.485C28.1396 4.975 28.3841 5.56334 28.3833 6.25V20C28.3833 20.6875 28.1383 21.2763 27.6483 21.7663C27.1583 22.2563 26.57 22.5008 25.8833 22.5H5.88331ZM5.88331 20H25.8833V6.25H5.88331V20Z",
    fill: "#86909C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApp);
export default __webpack_public_path__ + "static/media/icon_app.1c984f78b7f88888636dc53b2c9f1f59.svg";
export { ForwardRef as ReactComponent };